import { useAuth } from '../context/AuthContext';
import StudentDashboard from './StudentDashboard';
import DonorPortal from './DonorPortal';

export default function Dashboard() {
  const { user } = useAuth();

  if (user?.role === 'donor') {
    return <DonorPortal />;
  }

  return <StudentDashboard />;
}
